const e = "styles-module__container___18Pox", n = "styles-module__loader_spinner_container___ugZxk", _ = "styles-module__spin___IUQox", o = "styles-module__loader_text_container___pdrir", t = {
  container: e,
  loader_spinner_container: n,
  spin: _,
  loader_text_container: o
};
export {
  e as container,
  t as default,
  n as loader_spinner_container,
  o as loader_text_container,
  _ as spin
};
